import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../../components/Logo';
import LanguageToggle from '../../components/LanguageToggle';

export default function LegalPage({ docKey }) {
  const { t } = useTranslation();
  const doc = t(`legal.${docKey}`, { returnObjects: true });
  const sections = Array.isArray(doc.sections) ? doc.sections : [];

  return (
    <div className="min-h-screen bg-[#08080A] text-slate-200">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#08080A]/80 border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 py-3.5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2"><Logo /></Link>
          <div className="flex items-center gap-2">
            <LanguageToggle />
            <Link to="/" data-testid="legal-back" className="text-sm text-slate-400 hover:text-white transition-colors">
              {t('legal.back')}
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 data-testid="legal-title" className="font-display text-4xl md:text-5xl font-bold text-white mb-3">
          {doc.title}
        </h1>
        <div className="text-xs text-slate-500 mb-8">{t('legal.updated')}</div>
        {doc.intro && (
          <p className="text-slate-300 leading-relaxed mb-10 text-lg">{doc.intro}</p>
        )}
        <div className="space-y-8">
          {sections.map((s, i) => (
            <section key={`${s.h}-${i}`} className="border-l-2 border-indigo-500/30 pl-5">
              <h2 className="text-xl font-semibold text-white mb-3">{s.h}</h2>
              <p className="text-slate-400 leading-relaxed whitespace-pre-line">{s.p}</p>
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 text-xs text-slate-500">
          <Link to="/" className="text-indigo-400 hover:text-indigo-300">{t('legal.back')}</Link>
        </div>
      </main>
    </div>
  );
}
